/** @type {Record<string, string>} */
const initialValues = window.c3accessibility.getSettings();

if (!localStorage.getItem('c3accessibility.initialized')) {
    if (window.matchMedia('(prefers-contrast: more)').matches) {
        initialValues.colorFilter = 'high-contrast';
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        initialValues.reduceMotion = 'true';
    }
    window.c3accessibility.commitSettings(initialValues);
    localStorage.setItem('c3accessibility.initialized', 'true');
}

{
    const currentUrl = new URL(location);
    const newUrl = new URL(currentUrl);
    const searchParamRegex = /c3accessibility\[(?<settingsKey>.+)]/;
    let settingsKeyFound = false;
    for (const [key, value] of currentUrl.searchParams) {
        if (!key.startsWith('c3accessibility')) {
            continue;
        }

        const settingsKey = key.match(searchParamRegex).groups.settingsKey;
        if (!settingsKey) {
            continue;
        }

        settingsKeyFound = true;
        initialValues[settingsKey] = value;
        newUrl.searchParams.delete(key);
    }

    if (settingsKeyFound) {
        window.c3accessibility.commitSettings(initialValues);
        history.replaceState('', '', newUrl);
    }
}

customElements.define('c3accessibility-root', class extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({mode: 'open'});

        for (const style of c3accessibility.assets.styles) {
            const styleElement = document.createElement('link');
            styleElement.href = style;
            styleElement.rel = 'stylesheet';
            this.shadowRoot.append(styleElement);
        }

        this.shadowRoot.append(document.querySelector('#c3accessibility-template').content.cloneNode(true));

        this.buttons = {
            /** @type {HTMLButtonElement} */
            save: this.shadowRoot.querySelector('.c3accessibility-button[data-action="save"]'),
            /** @type {HTMLButtonElement} */
            cancel: this.shadowRoot.querySelector('.c3accessibility-button[data-action="cancel"]'),
        };

        this.elements = {
            /** @type {HTMLDialogElement} */
            dialog: this.shadowRoot.querySelector('#c3accessibility-dialog'),
            /** @type {HTMLButtonElement} */
            flag: this.shadowRoot.querySelector('#c3accessibility-flag'),
            /** @type {HTMLFormElement} */
            form: this.shadowRoot.querySelector('#c3accessibility-settings-form'),
        };

        const availableOptions = new Set(this.getAttribute('options').split(','));

        this.elements.flag.addEventListener('click', () => {
            viewTransition(() => {
                this.elements.dialog.showModal();
            });
        });

        this.elements.form.addEventListener('submit', e => {
            e.preventDefault();
            const data = new FormData(this.elements.form);
            const storedData = {};
            for (const [key, value] of data) {
                if (!availableOptions.has(key)) {
                    continue;
                }
                storedData[key] = value;
            }

            viewTransition(() => {
                window.c3accessibility.commitSettings(storedData);
                this.elements.dialog.close();
                window.dispatchEvent(new CustomEvent('c3accessibility:update', {
                    detail: {
                        data: storedData
                    }
                }));
            });
        });

        this.buttons.cancel.addEventListener('click', () => {
            viewTransition(() => {
                this.elements.dialog.close();
            });
            this.initDialogForm();
        });
    }

    connectedCallback() {
        this.initDialogForm();
    }

    initDialogForm() {
        /** @type {Record<string, 'radio' | 'select' | 'checkbox'>} */
        const fields = {
            fontSize: 'radio',
            lineHeight: 'radio',
            fontFamily: 'select',
          graphics: 'select',
            colorFilter: 'select',
            reduceMotion: 'checkbox'
        };

        for (const [key, value] of Object.entries(window.c3accessibility.getSettings())) {
            const type = fields[key];

            switch (type) {
                case 'radio': {
                    /** @type {HTMLInputElement} */
                    const element = this.elements.form.querySelector(`[name="${key}"][value="${value}"]`);
                    if (element) {
                        element.checked = true;
                    }
                    break;
                }
                case 'select': {
                    /** @type {HTMLSelectElement} */
                    const element = this.elements.form.querySelector(`[name="${key}"]`);
                    if (element) {
                        element.value = value;
                    }
                    break;
                }
                case 'checkbox': {
                    /** @type {HTMLInputElement} */
                    const element = this.elements.form.querySelector(`[name="${key}"]`);
                    if (element) {
                        element.checked = value === 'true';
                    }
                    break;
                }
            }
        }
    }
});

customElements.define('c3accessibility-icon', class extends HTMLElement {
    constructor() {
        super();
        this.icon = this.getAttribute('icon');
        this.src = window.c3accessibility.assets.icons[this.icon];
        this.content = fetch(this.src)
            .then(res => {
                if (!res.ok || res.status >= 400) {
                    return Promise.resolve(null);
                }
                return res.text();
            })
            .catch(() => null);
        this.setAttribute('aria-hidden', 'true');
    }

    connectedCallback() {
        this.content.then(res => {
            this.innerHTML = res;
        });
    }
});

window.addEventListener('load', function(){
    if ( document.documentElement.dataset.c3accessibilityReduceMotion === "true" ){
        document.querySelectorAll("video").forEach(vid => {
            vid.pause();
            vid.currentTime = 0;
            vid.removeAttribute('autoplay');
        });
    }
})

/**
 * polyfill function for view transitions. Does not show transition, if the browser does not support it
 * @param {() => void} callback
 */
function viewTransition(callback) {
    if (!document.startViewTransition) {
        callback();
        return {
            finished: Promise.resolve()
        };
    }

    return document.startViewTransition(() => {
        callback();
    });
}